import { IntegrationInitializationModal } from '../IntegrationInitializationModal'
import { IntegrationNotice } from '../IntegrationNotice'
import { useModals } from 'almanac-ui/Modal'
import Styles from '../IntegrationInitializationModal.module.scss'
import { GoHighLevel } from 'blaze-ui/icons'
import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const GoHighLevelNotice = () => (
  <IntegrationNotice
    connectionGuideLink="https://help.blaze.ai/en/articles/connect-blaze-to-gohighlevel"
    message={
      <div className={Styles.message}>
        To connect your GoHighLevel account for marketing automation and CRM integration, ensure:
        <ul className={Styles.list}>
          <li>You have admin access to the GoHighLevel agency or sub-account.</li>
          <li>Your account has the necessary permissions to create Private Integrations.</li>
          <li>You can generate API keys from Settings {'>'} Business Info within your location.</li>
          <li>Your GoHighLevel plan supports API access (Starter plan or higher).</li>
        </ul>
        <div className={Styles.note}>
          <strong>Note:</strong> GoHighLevel uses OAuth 2.0 authentication. You'll be redirected to GoHighLevel's secure
          login page to authorize Blaze's access to your account data.
        </div>
        <div className={Styles.note}>If you need help with the setup process, review our guide:</div>
      </div>
    }
  />
)

const GoHighLevelInitialization = ({ userIsAttemptingToPost = false, useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const title = userIsAttemptingToPost ? 'Set up your GoHighLevel integration' : 'Connect GoHighLevel Account'

  const sharedProps = {
    notice: <GoHighLevelNotice />,
    providerName: 'GoHighLevel',
    onClose: closeModal,
    icon: <GoHighLevel size={32} />,
    title,
    onConfirm: () => initiateOauth(ExternalIntegrationEnum.GoHighLevel),
    primaryButtonText: 'Go to GoHighLevel',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default GoHighLevelInitialization
